import { keyframes } from '@mui/material/styles';

export const enterDurationMs = 600;
export const exitDurationMs = 350;
/* The entering item waits until the leaving one has mostly cleared, so the two never collide at full opacity. */
export const enterDelayMs = 250;
export const staggerStepMs = 90;
/* Lists reveal many items, so each one gets more room than an element inside a single block. */
export const listStaggerStepMs = 200;
/* A leaving group stays mounted until its last staggered item has finished the exit. */
export const exitTotalMs = exitDurationMs + staggerStepMs;
export const enterEasing = 'cubic-bezier(0.33, 1, 0.68, 1)';
export const exitEasing = 'cubic-bezier(0.32, 0, 0.67, 0)';

export const riseIn = keyframes`
  from {
    opacity: 0;
    transform: translate3d(0, 16px, 0);
  }
  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
`;

export const riseOut = keyframes`
  from {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
  to {
    opacity: 0;
    transform: translate3d(0, -12px, 0);
  }
`;

export const slideInFromRight = keyframes`
  from {
    opacity: 0;
    visibility: hidden;
    transform: translate3d(20px, 0, 0);
  }
  to {
    opacity: 1;
    visibility: visible;
    transform: translate3d(0, 0, 0);
  }
`;

export const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

export const fadeOut = keyframes`
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
`;
